import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import moment from 'moment';

interface IVendas {
  emissao: string;
  nome: string;
  numero: number;
  total: number;
}

async function RelatorioVendasfabricacliente(dados: IVendas[], nome:string,periodo: string) {
  pdfMake.vfs = pdfFonts.pdfMake.vfs;

  if (dados.length === 0) {
    console.error('Nenhum dado disponível para gerar o relatório.');
    return;
  }

  // Calcula o total de vendas
  const TValorvendas = dados.reduce((acc, item) => acc + (item.total ?? 0), 0);

  // Mapeia os dados para criar a tabela
  const venda = dados.map((vendas) => {
    const { emissao, nome, numero, total } = vendas;

    return [
      { text: moment(emissao).format('DD/MM/YYYY'), alignment: 'center', fontSize: 8 },
      { text: numero || '-', alignment: 'center', fontSize: 8 },
      { text: nome || '-', alignment: 'left', fontSize: 8 },
      { text: new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2 }).format(total ?? 0), alignment: 'right', fontSize: 8 },
    ];
  });

  // Função para converter imagens em base64
  async function getBase64ImageFromUrl(url: string): Promise<string> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = 'Anonymous';
      img.onload = function () {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        if (!ctx) {
          reject('Não foi possível obter o contexto 2D');
          return;
        }
        canvas.height = img.naturalHeight;
        canvas.width = img.naturalWidth;
        ctx.drawImage(img, 0, 0);
        resolve(canvas.toDataURL('image/png'));
      };
      img.onerror = function () {
        reject(`Não foi possível carregar a imagem de ${url}`);
      };
      img.src = url;
    });
  }

  // Carrega a imagem do logo
  const imageUrl = process.env.REACT_APP_URL_IMAGLOG || '';
  let imageData = '';
  try {
    imageData = await getBase64ImageFromUrl(imageUrl);
  } catch (error) {
    console.error('Erro ao carregar a imagem:', error);
  }

  const documentDefinition: any = {
    pageSize: 'A4',
    pageMargins: [20, 10, 20, 10],
    pageOrientation: 'portrait',
    header: 'Relatório de Vendas Por Fábrica Cliente',
    footer: {
      columns: ['Esquerda', { text: 'Direita', alignment: 'right' }],
    },
    content: [
      {
        table: {
          widths: [50, '*'],
          body: [
            [
              {
                image: imageData,
                width: 80,
                border: [false, false, false, false],
              },
              {
                text: 'Relatório de Vendas Por Fábrica Cliente',
                fontSize: 20,
                bold: true,
                alignment: 'center',
                margin: [0, 15, 0, 0],
                border: [false, false, false, false],
              },
            ],
          ],
        },
      },
      { text: `Fábrica: ${nome}`, fontSize: 10, margin: [0, 1, 0, 10] },
      { text: `${periodo}`, fontSize: 10, margin: [0, 2, 0, 5] },
      {
        table: {
          widths: [70, 70, '*', 70],
          body: [
            [
              { text: 'Emissão', alignment: 'center', fillColor: '#dddddd', fontSize: 8 },
              { text: 'Número', alignment: 'center', fillColor: '#dddddd', fontSize: 8 },
              { text: 'Nome', alignment: 'center', fillColor: '#dddddd', fontSize: 8 },
              { text: 'Total', alignment: 'center', fillColor: '#dddddd', fontSize: 8 },
            ],
            ...venda,
            [
              { text: 'Total:', colSpan: 3, alignment: 'right', bold: true, fontSize: 8 },
              {},
              {},
              {
                text: new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2 }).format(TValorvendas),
                alignment: 'right',
                fontSize: 8,
                bold: true,
              },
            ],
          ],
        },
      },
    ],
  };

  const pdfDocGenerator = pdfMake.createPdf(documentDefinition);
  pdfDocGenerator.open();
}

export default RelatorioVendasfabricacliente;
